import { migrateTraversal } from "../helpers/migrateTraversal";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderMigrationNode, IWebsiteBuilderSchemaVersionMigrationNode } from "../helpers/migrationNode";
import { WebsiteBuilderMigrationError } from "../helpers/migrationError";

type TMigrateLayoutDataV4Result = {
  height: number;
}

type TMigrateLayoutV4Result = {
  desktop: TMigrateLayoutDataV4Result;
  tablet: TMigrateLayoutDataV4Result;
  mobile: TMigrateLayoutDataV4Result;
}

export interface IMigrateSectionV3Input extends IWebsiteBuilderMigrationNode {
  type: "section";
  section: {
    height: number;
  }
}

export interface IMigrateSectionV4Result extends IWebsiteBuilderMigrationNode {
  type: "section";
  section: {
    layout: TMigrateLayoutV4Result;
  }
}

function isMigrateSectionV3Input(node: any): node is IMigrateSectionV3Input {
  const partialNode: Partial<IMigrateSectionV3Input> = node;

  return (
    partialNode?.type === "section" &&
    partialNode.section?.height != null
  );
}

export function migrateSchemaV3ToV4(node: IWebsiteBuilderSchemaVersionMigrationNode): IWebsiteBuilderSchemaVersionMigrationNode {
  if (node.schemaVersion !== 3) {
    throw new WebsiteBuilderMigrationError({
      type: "cannot-migrate-from-schema-version",
      schemaVersion: node.schemaVersion,
      nextSchemaVersion: 4,
    });
  }

  function migrateNode(prev: IWebsiteBuilderMigrationNode): IWebsiteBuilderMigrationNode {
    if (prev?.type === "section") {
      if (!isMigrateSectionV3Input(prev)) {
        throw new WebsiteBuilderMigrationError({
          type: "section-missing-field",
          schemaVersion: 3,
          nextSchemaVersion: 4,
        });
      }
      
      const sectionBaseV4Result: IMigrateSectionV3Input = cloneDeep(prev);

      const sectionLayoutV4Result: TMigrateLayoutV4Result = {
        desktop: {
          height: sectionBaseV4Result.section.height,
        },
        tablet: {
          height: sectionBaseV4Result.section.height,
        },
        mobile: {
          height: sectionBaseV4Result.section.height,
        },
      };

      delete sectionBaseV4Result.section.height;

      const sectionV4Result: IMigrateSectionV4Result = {
        ...sectionBaseV4Result,
        section: {
          ...sectionBaseV4Result.section,
          layout: sectionLayoutV4Result,
        },
      };
      
      return sectionV4Result;
    } else {
      return prev;
    }
  }

  return {
    ...migrateTraversal(node, migrateNode),
    schemaVersion: 4,
  };
}